// extracted by mini-css-extract-plugin
module.exports = {"pagination":"blog-list-styles-module--pagination--2_1sB","active":"blog-list-styles-module--active--11rcS"};